import React from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { _t } from 'utils';
import { formField } from 'types';

export default ({ item = {}, dcId }) => {
  const { id, ...editProps } = item;
  const model = {
    name: '', ip: '', dhcp: true, ...editProps,
  };

  const fields = [
    formField.text({ name: 'name', title: _t('Name') }),
    formField.ip({ name: 'ip', title: 'IP (Optional)' }),
    formField.switch({ name: 'dhcp', title: 'DHCP' }),
  ];

  const validations = [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'name', type: VALIDATION.STRING, max: 255 },
    { name: 'ip', type: VALIDATION.IP_V4 },
  ];

  const onSave = (properties) => {
    if (id) return actions.loadbalancer.update({ dcId, id, properties });
    if (!properties.ip) delete properties.ip;
    return actions.loadbalancer.create({ dcId, properties });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={model}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
    />
  );
};
